import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core'

import { FlxButtonComponent } from '@flowx/angular-ui-toolkit'

import { FlxNotificationContextComponent } from '../notification-context/notification-context.component'
import { FlxNotificationSummaryComponent } from '../notification-summary/notification-summary.component'
import { ExtendedNotification, VISUALS_BY_STATUS } from '../notifications.model'
import { NotificationActionsService } from '../services/notification-actions.service'

@Component({
  selector: 'flx-notification-content',
  imports: [FlxButtonComponent, FlxNotificationContextComponent, FlxNotificationSummaryComponent],
  templateUrl: './notification-content.component.html',
  host: {
    class: 'flex items-start gap-2 min-w-0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxNotificationContentComponent {
  #notificationActionsService = inject(NotificationActionsService)

  notification = input.required<ExtendedNotification>()

  actionClicked = output<void>()

  statusVisuals = computed(() => VISUALS_BY_STATUS[this.notification().status])

  runAction(): void {
    this.#notificationActionsService.runAction(this.notification())
    this.actionClicked.emit()
  }
}
